import {
    type DeleteSubEventResponseType,
    type DeleteSubEventRequestType
} from "./type";
import {
    request
} from "../request";

const DeleteSubEvent = async (params: DeleteSubEventRequestType): Promise<DeleteSubEventResponseType> => {
    return await request<DeleteSubEventResponseType>(`/events/deleteSubEvent?eventID=${params.eventID}&eventSubID=${params.eventSubID}`, {
        method: "DELETE"
    });
};

export default DeleteSubEvent;
